import React from 'react';

import { Box } from '@mui/material';
import { GridToolbar, GridPagination, GridFooterContainer } from '@mui/x-data-grid';

export interface TxFooterProps {
  hideToolbar?: boolean;
  hidePageSizeSelector?: boolean;
  [key: string]: any; // Aceita qualquer outra prop do MUI
}

export function TxFooter(props: TxFooterProps) {
  const { hideToolbar = false, hidePageSizeSelector = false, ...rest } = props;
  return (
    <GridFooterContainer
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: hideToolbar ? 'flex-end' : 'space-between',
        alignItems: 'center',
        p: 0,
        minHeight: '40px',
        '& .MuiDataGrid-toolbarContainer': {
          padding: '8px',
        },
        '& .MuiTablePagination-root': {
          minHeight: '40px',
        },
        '& .MuiTablePagination-toolbar': {
          minHeight: '40px',
          height: '40px',
          padding: '0 4px',
        },
        ...(hidePageSizeSelector && {
          '& .MuiTablePagination-selectLabel': { display: 'none' },
          '& .MuiTablePagination-select': { display: 'none' },
          '& .MuiTablePagination-selectIcon': { display: 'none' },
        }),
      }}
    >
      {!hideToolbar && (
        <Box sx={{ flexGrow: 0 }}>
          <GridToolbar />
        </Box>
      )}
      <Box>
        <GridPagination />
      </Box>
    </GridFooterContainer>
  );
}
